export default function (duration, byController) {
  const swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}



// WEBPACK FOOTER //
// ../src/components/core/transition/setTransition.js